module.exports = __webpack_public_path__ + "img/upload_resume.487dace7.svg";